import "./hoverTip.css";

/**
 * `v-hover-tip="texto"`: el mismo globo que la «i» de los campos del
 * formulario (FormRenderer.vue), para usar en lugar de `title`. El `title`
 * nativo tarda casi un segundo en abrirse y sale con el estilo del sistema
 * operativo; este se abre al pasar el mouse.
 *
 * El globo va en el body para que no lo recorte un contenedor con overflow
 * (las celdas del calendario) y se ubica debajo del elemento, o arriba si
 * no entra.
 */

const GAP = 6;
const MARGIN = 8;

function show(el) {
  const text = el._hoverTip && el._hoverTip.text;
  if (!text) return;
  hide(el);

  const tip = document.createElement("div");
  tip.className = "hover-tip";
  tip.setAttribute("role", "tooltip");
  tip.textContent = text;
  document.body.appendChild(tip);
  el._hoverTip.node = tip;

  const rect = el.getBoundingClientRect();
  const width = tip.offsetWidth;
  const height = tip.offsetHeight;
  const left = Math.min(
    Math.max(rect.left, MARGIN),
    window.innerWidth - width - MARGIN
  );
  const below = rect.bottom + GAP;
  const top = below + height <= window.innerHeight - MARGIN
    ? below
    : Math.max(rect.top - GAP - height, MARGIN);

  tip.style.left = `${left}px`;
  tip.style.top = `${top}px`;
}

function hide(el) {
  const node = el._hoverTip && el._hoverTip.node;
  if (node && node.parentNode) node.parentNode.removeChild(node);
  if (el._hoverTip) el._hoverTip.node = null;
}

export default {
  bind(el, binding) {
    el._hoverTip = {
      text: binding.value ? String(binding.value) : "",
      node: null,
      onEnter: () => show(el),
      onLeave: () => hide(el),
    };
    el.addEventListener("mouseenter", el._hoverTip.onEnter);
    el.addEventListener("mouseleave", el._hoverTip.onLeave);
    // El click suele abrir o desplegar algo: el globo quedaría tapándolo.
    el.addEventListener("click", el._hoverTip.onLeave);
    window.addEventListener("scroll", el._hoverTip.onLeave, true);
  },
  update(el, binding) {
    const text = binding.value ? String(binding.value) : "";
    if (text === el._hoverTip.text) return;
    el._hoverTip.text = text;
    if (el._hoverTip.node) {
      if (text) show(el);
      else hide(el);
    }
  },
  unbind(el) {
    hide(el);
    el.removeEventListener("mouseenter", el._hoverTip.onEnter);
    el.removeEventListener("mouseleave", el._hoverTip.onLeave);
    el.removeEventListener("click", el._hoverTip.onLeave);
    window.removeEventListener("scroll", el._hoverTip.onLeave, true);
    delete el._hoverTip;
  },
};
